/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Manufacturer_InvalidInputs */

const en_error_manufacturer_invalid = /** @type {(inputs: Error_Manufacturer_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The manufacturer cannot be saved as it is:`)
};

/**
* | output |
* | --- |
* | "The manufacturer cannot be saved as it is:" |
*
* @param {Error_Manufacturer_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_manufacturer_invalid = /** @type {((inputs?: Error_Manufacturer_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Manufacturer_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_manufacturer_invalid(inputs)
});